// extracted by mini-css-extract-plugin
export var button = "_8p-7";
export var buttonRow = "_8p-6";
export var fadeIn = "_8p-1";
export var gradient = "_8p-0";
export var panel = "_8p-2";
export var panelIn = "_8p-3";
export var subtitle = "_8p-5";
export var title = "_8p-4";